function img_track(key,message) {
  let
    today = new Date(),
    date = today.getFullYear()+'_'+(today.getMonth()+1)+'_'+today.getDate(),
    time = today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds(),
    dateTime = date+'-'+time,
    src = '/comun/img/dtm-track.jpg',
    querystring = encodeURI('key='+key+'&datetime='+dateTime+'&message='+message),
    img = document.createElement('img')
  ;
  img.src = src+'?'+querystring;
  return img;
}

try {
  let titulardtm = '';
  if (voc_tn.indexOf(".") > -1) {
    titulardtm = window.voc_tn.substring(0, voc_tn.indexOf("."));
  } else {
    titulardtm = window.voc_tn;
  }
  let slotnum = '';
  TagManager.ready.then(function () {
      if(window.vocento.tracking.root.httpStatus === '200') {
          TagManager.set({
              titular: titulardtm,
              slot: slotnum,
              modulosRotacion: window.modulosRotacion,
              idNoticia: window.idNoticia
          }).track();
      } else {
          if (window.voc_tn.indexOf(".") > -1) {
              titulardtm = window.voc_tn.substring(0, window.voc_tn.indexOf("."));
          } else {
              titulardtm = window.voc_tn;
          }
          TagManager.set({
              titular: titulardtm,
              slot: slotnum,
              errorPagina: '404'
          }).track();
      }
  },function (result) {
      img_track('dtm-error-promise-result',result);
  });
} catch (ex) {
  img_track('dtm-error-exception',ex);
}


// WEBPACK FOOTER //
// ./src/tracking/dtm.js